import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
  ApplicationCategory, EducationLevel,
  FacilityType,
  MLevel,
  MRLevel,
  ProductType,
  ProfessionalField,
  ProfessionalType, QualificationType, SpecificProductItem
} from '../../models/CommonModels';
import {CommonService} from '../../shared/services/common.service';
import * as Constants from '../../models/Constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  EducationLevelConfig,
  ProfessionalConfigFilter,
  ProfessionalFieldConfig,
  ProfessionalTypeConfig,
  QualificationConfig
} from '../../models/ProfessionalType';
import {SettingsService} from '../../shared/services/settings.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {NgxSpinnerService} from 'ngx-spinner';
import {AlertService} from '../../shared/services/alert.service';

@Component({
  selector: 'app-professional-config',
  templateUrl: './professional-config.component.html',
  styleUrls: ['./professional-config.component.css']
})
export class ProfessionalConfigComponent implements OnInit {
  // Lists
  public facilityTypes: FacilityType[];
  public productTypes: ProductType[];
  public applicationCategories: ApplicationCategory[];
  public professionalTypes: ProfessionalType[];
  public manufacturingLevel: MLevel[];
  public manufacturingRiskLevel: MRLevel[];
  public allManufacturingRiskLevel: MRLevel[];
  public qualificationTypes: QualificationType[];
  public eduLevels: EducationLevel[];
  public specificProductItems: SpecificProductItem[];
  public fieldsList: ProfessionalField[];
  // Identify visibility of filters
  public manufacturerFacilityTypeID: number;
  public foodManufacturerSelected = false;
  public medicalDeviceSelected = false;
  public cosmeticsManufacturerSelected = false;
  // Objects in view
  public expandedProfessionalType: ProfessionalType;
  public professionalToBeExpanded: ProfessionalType;
  public selectedProfessionalActive = false;
  public selectedProfessionalRequired = false;
  public selectedProfessionalField: ProfessionalField;
  public selectedProfessionalFieldIndex: number;
  public showEducationLookup: boolean;
  public showEduQualAss: boolean;
  public showQualLookups: boolean;
  public alertMessage = '';
  public actionType = '';
  public constants: any = Constants;
  public modalRef: BsModalRef;
  // Config Models
  public professionalTypeConfigForm: FormGroup;
  public selectedProfessionalTypeConfig: ProfessionalTypeConfig;
  public selectedEducationLevelConfig: EducationLevelConfig[] = [];
  public professionalConfigListForFilter: ProfessionalTypeConfig[];
  public professionalConfigFilter: ProfessionalConfigFilter;
  public existingProfRequiredEdited: boolean = false;
  public selectAllEduLevelLookupChecked: boolean = false;
  public selectAllQuaificationLookupChecked: boolean = false;

  @ViewChild('alertModal', { static: true }) templateRef: TemplateRef<any>;

  constructor(private commonService: CommonService, private fb: FormBuilder, private settingsService: SettingsService,
              private modalService: BsModalService, private spinner: NgxSpinnerService, private alertService: AlertService) { }

  ngOnInit() {
    this.getFacilityTypes();
    this.getApplicationCategories();
    this.getmRLevels();
    this.getmLevels();
    this.getQualificationTypes();
    this.getEduLeveles();
    this.productTypes = [];
    this.professionalConfigFilter = new ProfessionalConfigFilter();
  }


  getFacilityTypes(): void {
    this.facilityTypes = [];
    this.commonService.getFacilityTypes(true).subscribe(facilityTypes => {
      this.facilityTypes = facilityTypes;
      this.getProductTypes();
    });
  }

  getProductTypes() {
    const _this = this;
    if (this.facilityTypes) {
      this.facilityTypes.forEach(function(ft, index) {
        _this.commonService.getProductTypes(ft.id).subscribe(productTypes => {
          if (productTypes && productTypes.length) {
            this[index].productTypes = productTypes;
          }
          if (ft.name === Constants.MANUFACTURER) {
            _this.manufacturerFacilityTypeID = ft.id;
          }
        });
      }, this.facilityTypes);
    }
  }

  getProfessionalTypes(): void {
    const _this = this;
    this.commonService.getProfessionalTypes().subscribe( professionalTypes => {
      this.professionalTypes = professionalTypes;
      if (this.professionalTypes) {
        this.professionalTypes.forEach(function(pt, index) {
          this[index].professionalFields = _this.fieldsList;
        }, this.professionalTypes);
      }
    });
  }

  getQualificationTypes(): void {
    this.commonService.getQualificationTypes().subscribe( qualificationTypes => {
      this.qualificationTypes = qualificationTypes;
    });
  }

  getEduLeveles(): void {
    this.commonService.getEducationLevels(false).subscribe( eduLevels => {
      this.eduLevels = eduLevels;
    });
  }

  getSpecificProductItems(): void {
    this.commonService.getSpecificProductItemsByFacilityTypeAndProductType(this.professionalConfigFilter.facilityTypeID,
                                                                        this.professionalConfigFilter.productTypeID).subscribe( sp => {
      this.specificProductItems = sp;
      let medDevSpItems = [Constants.SP_ITEM_APRON, Constants.SP_ITEM_FACE_SHIELDS,Constants.SP_ITEM_GLOVES_NON_STERILE, 
        Constants.SP_ITEM_GLOVES_STERILE, Constants.SP_ITEM_GOOGLES,Constants.SP_ITEM_COVER_GOWN,Constants.SP_ITEM_SHOE_COVER,
        Constants.SP_ITEM_STERILE_MEDICAL_MASK, Constants.SP_ITEM_NON_STERILE_MEDICAL_MASK, Constants.SP_ITEM_RESPIRATOR, Constants.SP_ITEM_LAB_SCREENING_KIT,
        Constants.SP_ITEM_LAB_CONFIRMATION_KIT, Constants.SP_ITEM_RT_PCR_KIT,Constants.SP_ITEM_EXTRACTION_KIT, Constants.SP_ITEM_CARTRIDGES,
        Constants.SP_ITEM_SWAB, Constants.SP_ITEM_PULSE_OXIMETER,Constants.SP_ITEM_CONCENTRATOR, Constants.SP_ITEM_NASAL_OXYGEN_CANNULA,
        Constants.SP_ITEM_VENTILATOR_PATIENT, Constants.SP_ITEM_IR_THERMOMETER,Constants.SP_ITEM_CPAP,Constants.SP_ITEM_SUCTION_PUMP,
        Constants.SP_ITEM_HIGH_FLOW_NASAL_CANNULA, Constants.SP_ITEM_MEDICAL_MASK, Constants.SP_ITEM_COVID_TEST_KIT];
      // filter out specific product items added for temp coc
      this.specificProductItems = this.specificProductItems.filter(s => medDevSpItems.indexOf(s.name.trim()) === -1);
    });
  }

  getApplicationCategories(): void {
    this.commonService.getApplicationCategories().subscribe( applicationCategories => {
      this.applicationCategories = applicationCategories.filter(apCat =>
        [Constants.APPLICATION_TYPE_CODE_NEW, Constants.APPLICATION_TYPE_CODE_TEMP_COC,
          Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE].indexOf(apCat.applicationCategoryCode) > -1);
    });
  }

  facilityTypeSelected() {
    const selectedFacilityType = this.facilityTypes.find(ft => ft.id === this.professionalConfigFilter.facilityTypeID);
    const appCat = this.applicationCategories.find(ac => ac.id === this.professionalConfigFilter.applicationCategoryID);
    if (appCat.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_COC) {
      this.productTypes = selectedFacilityType.productTypes.filter(pt => pt.name.indexOf('Med') > -1);
    } else {
      this.productTypes = selectedFacilityType.productTypes;
    }
    if (this.professionalConfigFilter.productTypeID) {
      this.facilityTypeAndProductTypeChanged();
    }
  }

  public applicationCategoryChanged() {
    const appCat = this.applicationCategories.find(ac => ac.id === this.professionalConfigFilter.applicationCategoryID);
    if (appCat.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_COC) {
      this.medicalDeviceSelected = false;
    } else {
      if (this.professionalConfigFilter.productTypeID) {
        this.facilityTypeAndProductTypeChanged();
      }
    }  
    if (this.professionalConfigFilter.facilityTypeID) {
      const selectedFacilityType = this.facilityTypes.find(ft => ft.id === this.professionalConfigFilter.facilityTypeID);
      if (selectedFacilityType) {
        if (appCat.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_COC) {
          this.productTypes = selectedFacilityType.productTypes.filter(pt => pt.name.indexOf('Med') > -1);
        } else {
          this.productTypes = selectedFacilityType.productTypes;
        }
      }
    }
  }

  getmLevels(): void {
    this.commonService.getMLevels().subscribe(mLevels => this.manufacturingLevel = mLevels);
  }

  getmRLevels(): void {
    this.commonService.getMRLevels().subscribe(mRLevels => {
        this.manufacturingRiskLevel = mRLevels;
        this.allManufacturingRiskLevel = mRLevels;
      }
    );
  }

  getProfessionalFields(): void {
    this.commonService.getProfessionalFields().subscribe(professionalFields => {
        this.fieldsList = professionalFields;
      const expLabel = this.fieldsList.map(function(el) {
        return el.name;
      }).indexOf(Constants.EXPERIENCE_LABEL);
      let qualEduField = new ProfessionalField();
      qualEduField.name = Constants.QUAL_EDU_ASSOCIATION_LABEL;

      this.fieldsList.splice(expLabel + 1, 0, qualEduField);
      this.getProfessionalTypes();
      }
    );
  }

  getProfessionalConfigByFilter(): void {
    this.spinner.show();
    this.settingsService.getProfessionalConfigListByFilter(this.professionalConfigFilter).subscribe(professionalFieldConfigList => {
        this.professionalConfigListForFilter = professionalFieldConfigList;
      }, err => {
        this.alertService.error('Unable to fetch configurations. Please try again later.');
      }, () => {
          this.spinner.hide();
      }
    );
  }

  specificProductItemSelected(specificProductItems : SpecificProductItem[]) {
    this.professionalConfigFilter.specificProductItemIDs = [specificProductItems[0].id];
  }

  facilityTypeAndProductTypeChanged() {
    this.getSpecificProductItems();
    const productType = this.productTypes.find(pt => pt.id === this.professionalConfigFilter.productTypeID);
    const appCategory = this.applicationCategories.find(a => a.id === this.professionalConfigFilter.applicationCategoryID);
    this.medicalDeviceSelected = appCategory.applicationCategoryCode == Constants.APPLICATION_TYPE_CODE_NEW && 
              productType.name === Constants.PRODUCT_TYPE_MED_DEVICES;
    if (!this.medicalDeviceSelected) {
      this.professionalConfigFilter.specificProductItemIDs = null;
    }
    // check if food manufacturing
    if (this.professionalConfigFilter.facilityTypeID && this.professionalConfigFilter.productTypeID &&
      this.professionalConfigFilter.facilityTypeID === this.manufacturerFacilityTypeID) {
        this.foodManufacturerSelected = productType.name === Constants.PRODUCT_TYPE_FOOD;
        this.cosmeticsManufacturerSelected = productType.name === Constants.PRODUCT_TYPE_COSMETICS;

        if (!this.foodManufacturerSelected && !this.cosmeticsManufacturerSelected) {
          this.professionalConfigFilter.manufacturingLevelID = null;
          this.professionalConfigFilter.manufacturingRiskLevelID = null;
        } 

        if(this.cosmeticsManufacturerSelected) this.professionalConfigFilter.manufacturingRiskLevelID = null;
    } else {
      this.foodManufacturerSelected = false;
      this.cosmeticsManufacturerSelected = false;
      this.professionalConfigFilter.manufacturingLevelID = null;
      this.professionalConfigFilter.manufacturingRiskLevelID = null;
    }
  }

  expandConfigView(professional, hasConfig) {
      this.expandedProfessionalType = professional;
      this.selectProfessionalField(this.expandedProfessionalType.professionalFields[0]);
      if (hasConfig) {
        this.initializeEditForm();
      } else {
        this.initializeForm();
        this.selectedProfessionalTypeConfig = new ProfessionalTypeConfig();
        this.selectedProfessionalTypeConfig.applicationCategoryID = this.professionalConfigFilter.applicationCategoryID;
        this.selectedProfessionalTypeConfig.facilityTypeID = this.professionalConfigFilter.facilityTypeID;
        this.selectedProfessionalTypeConfig.productTypeID = this.professionalConfigFilter.productTypeID;
        this.selectedProfessionalTypeConfig.manufacturingLevelID = this.professionalConfigFilter.manufacturingLevelID;
        this.selectedProfessionalTypeConfig.manufacturingRiskLevelID = this.professionalConfigFilter.manufacturingRiskLevelID;
        this.selectedProfessionalTypeConfig.professionalTypeID = this.expandedProfessionalType.id;
      }
  }

  selectProfessionalField(field) {
    if (!this.disableField(field)) {
      this.selectedProfessionalFieldIndex = this.fieldsList.indexOf(field);
      this.selectedProfessionalField = field;
      this.showEducationLookup = [Constants.EDUCATION_LEVEL_LABEL].indexOf(field.name) > -1;
      this.showQualLookups = [Constants.QUALIFICATION_LABEL].indexOf(field.name) > -1;
      this.showEduQualAss = [Constants.QUAL_EDU_ASSOCIATION_LABEL].indexOf(field.name) > -1;
      if (this.showEduQualAss) {
        this.configureEducationField();
        this.selectedProfessionalTypeConfig.educationLevelConfig.sort(function (a, b) {
          return a.educationLevel.rank - b.educationLevel.rank;
        });
      }
    }
  }

  disableField(field) {
    if(field.name != 'Name' && field.name !=  Constants.EDUCATION_LEVEL_LABEL ){
      const selectedEduArray = this.professionalTypeConfigForm.get('EDL').get('selectedValues').value;
      
      if(field.name == Constants.QUALIFICATION_LABEL){       
        return selectedEduArray ? selectedEduArray.every(e => e == false) : true;
      
      }else{
        const selectedQualArray = this.professionalTypeConfigForm.get('QUA').get('selectedValues').value;
        
        return selectedEduArray && selectedQualArray ? 
           selectedEduArray.every(e => e == false) || selectedQualArray.every(q => q == false) : true;
      }
    }
    return false;
  }

  configureEducationField() {

    if (this.professionalTypeConfigForm.controls[Constants.QUAL_CODE].get('selectedValues').dirty ||
    this.professionalTypeConfigForm.controls[Constants.EDUCATION_LEVEL_CODE].get('selectedValues').dirty) {
      let eduLevelConfigs = [];
      const selectedEduArray = this.professionalTypeConfigForm.get('EDL').get('selectedValues').value;
      const selectedEduIndexes = selectedEduArray.reduce((acc, el, i) => (el === true ? [...acc, i] : acc), []);
      const selectedQualArray = this.professionalTypeConfigForm.get('QUA').get('selectedValues').value;
      const selectedQualIndexes = selectedQualArray.reduce((acc, el, i) => (el === true ? [...acc, i] : acc), []);
      selectedEduIndexes.forEach(eduLevelIndex => {
        let educationLevel = this.eduLevels[eduLevelIndex];
        let persistedEduLevelConfig;
        if (this.selectedProfessionalTypeConfig && this.selectedProfessionalTypeConfig.educationLevelConfig) {
          persistedEduLevelConfig = this.selectedProfessionalTypeConfig.educationLevelConfig.find(
            elc => elc.educationLevelID === educationLevel.id);
        }

        let eduLevelConfig = new EducationLevelConfig();
        if(this.selectedEducationLevelConfig.length == 0 || 
            this.selectedEducationLevelConfig.findIndex(ec => ec.educationLevelID == educationLevel.id) === -1){ 

          eduLevelConfig.educationLevelID = educationLevel.id;
          eduLevelConfig.educationLevel = educationLevel;
          if (persistedEduLevelConfig) {
            eduLevelConfig.id = persistedEduLevelConfig.id;
          }
        }else {
          eduLevelConfig = this.selectedEducationLevelConfig.find(ec => ec.educationLevelID == educationLevel.id);
        }
        
        if (['10G', '12D'].indexOf(educationLevel.educationLevelCode) === -1) {
          let qualConfigList = [];
          selectedQualIndexes.forEach(qualIndex => {

            const qualificationType = this.qualificationTypes[qualIndex];
            let persistedQualConfig;
            if (persistedEduLevelConfig) {
              persistedQualConfig = persistedEduLevelConfig.qualificationConfig.find(qc => qc.qualificationID === qualificationType.id);
            }

            if(eduLevelConfig.qualificationConfig.length == 0 ||
              eduLevelConfig.qualificationConfig.findIndex(qc => qc.qualificationID == qualificationType.id) === -1){
                if (!persistedQualConfig) {
                  let qualConfig = new QualificationConfig();
                  qualConfig.qualificationID = qualificationType.id;
                  qualConfig.qualification = qualificationType;
                  qualConfig.isSelected = true;
                  qualConfig.minExperience = 0;
                  qualConfigList.push(qualConfig);
                } else {
                  persistedQualConfig.isSelected = true;
                  qualConfigList.push(persistedQualConfig);
                }
            } else {
              qualConfigList.push(eduLevelConfig.qualificationConfig.find(qc => qc.qualificationID == qualificationType.id));
            } 

          });
          eduLevelConfig.qualificationConfig = qualConfigList;
        }
        
        eduLevelConfigs.push(eduLevelConfig);
      });

      this.selectedEducationLevelConfig = eduLevelConfigs;
    } else if(this.selectedEducationLevelConfig.length == 0){
      
      this.selectedProfessionalTypeConfig.educationLevelConfig.forEach(elc => {
        elc.qualificationConfig.forEach(qc => {
          qc.isSelected = true;
        });
      });
      this.selectedEducationLevelConfig = this.selectedProfessionalTypeConfig.educationLevelConfig;
    }
  }

  nextClicked() {
    this.selectProfessionalField(this.fieldsList[this.selectedProfessionalFieldIndex + 1]);
  }

  previousClicked() {
    this.selectProfessionalField(this.fieldsList[this.selectedProfessionalFieldIndex - 1]);
  }

  buildLookupForm(fieldName, educationLevelConfig) {
    let arr;
    if (fieldName === Constants.QUALIFICATION_LABEL) {
      arr = this.qualificationTypes.map(qt => {
        if (educationLevelConfig) {
          let selectedQualIds = educationLevelConfig.map(a => {
            return a.qualificationConfig.map(b => b.qualificationID);
          });
          selectedQualIds = [].concat.apply([], selectedQualIds);
          selectedQualIds.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });
          const qual = selectedQualIds.find(id => id === qt.id);
          return this.fb.control(Boolean(qual));
        } else {
          return this.fb.control(Boolean(qt.isSelected));
        }
      });
    } else {
      arr = this.eduLevels.map(edu => {
        if (educationLevelConfig) {
          const elc = educationLevelConfig.find(el => el.educationLevelID === edu.id);
            return this.fb.control(Boolean(elc));
        } else {
          return this.fb.control(Boolean(edu.isSelected));
        }
      });
    }
    return this.fb.array(arr);
  }

  initializeForm() {
    this.professionalTypeConfigForm = this.fb.group({});
    this.fieldsList.forEach(field => {
      if ([Constants.QUALIFICATION_LABEL, Constants.EDUCATION_LEVEL_LABEL].indexOf(field.name) > -1) {
        this.professionalTypeConfigForm.addControl(
          field['professionalFieldCode'], this.fb.group( {
            required: [false, Validators.required],
            active: [false, Validators.required],
            fieldID: [field['id'], Validators.required],
            selectedValues: this.buildLookupForm(field.name, null)
          }));
      } else if (field.name !== Constants.QUAL_EDU_ASSOCIATION_LABEL) {
        this.professionalTypeConfigForm.addControl(
          field['professionalFieldCode'], this.fb.group( {
            required: [false, Validators.required],
            active: [false, Validators.required],
            fieldID: [field['id'], Validators.required]
          }));
      }
    });
    this.qualificationTypes.map(e => ({...e, isSelected: false}));
    this.eduLevels.map(e => ({...e, isSelected: false}));
  }

  initializeEditForm() {
    const config = this.professionalConfigListForFilter.find(profConfig =>
                                                            profConfig.professionalTypeID === this.expandedProfessionalType.id);
    this.selectedProfessionalTypeConfig = config;
    if (config) {
      this.professionalTypeConfigForm = this.fb.group({});
      this.fieldsList.forEach(field => {
        const fieldConfig = config.professionalFieldConfig.find(prFieldConfig => prFieldConfig.professionalFieldID === field.id);
        if (fieldConfig) {
          if ([Constants.QUALIFICATION_LABEL, Constants.EDUCATION_LEVEL_LABEL].indexOf(field.name) > -1) {
            this.professionalTypeConfigForm.addControl(
              field['professionalFieldCode'], this.fb.group( {
                required: [fieldConfig.required, Validators.required],
                active: [fieldConfig.active, Validators.required],
                fieldID: [field['id'], Validators.required],
                selectedValues: this.buildLookupForm(field.name, config.educationLevelConfig)
              }));
          } else if (field.name !== Constants.QUAL_EDU_ASSOCIATION_LABEL) {
            this.professionalTypeConfigForm.addControl(
              field['professionalFieldCode'], this.fb.group( {
                required: [fieldConfig.required, Validators.required],
                active: [fieldConfig.active, Validators.required],
                fieldID: [field['id'], Validators.required]
              }));
          }
        }
      });
      this.qualificationTypes.map(e => ({...e, isSelected: false}));
      this.eduLevels.map(e => ({...e, isSelected: false}));
    } else {
      this.initializeForm();
    }
  }

  submitConfig() {
    
    this.spinner.show();
    let professionalFieldConfigList = [];
    for (let controlsKey in this.professionalTypeConfigForm.controls) {
      const keyValue = this.professionalTypeConfigForm.controls[controlsKey];
      const fieldConfig = new ProfessionalFieldConfig();
      fieldConfig.professionalFieldID = keyValue.value.fieldID;
      fieldConfig.required = keyValue.value.required;
      fieldConfig.active = keyValue.value.active;
      professionalFieldConfigList.push(fieldConfig);
    }
    this.configureEducationField();
    this.selectedProfessionalTypeConfig.educationLevelConfig = this.selectedEducationLevelConfig;
    this.filterOutRemovedQualificationsFromEduConfig();
    this.selectedProfessionalTypeConfig = this.removeLookupsFromProfessionalTypeConfig(this.selectedProfessionalTypeConfig);
    if (this.selectedProfessionalTypeConfig.id) {

      this.selectedProfessionalTypeConfig.professionalFieldConfig.forEach(pfc => {
        let index = professionalFieldConfigList.findIndex(opfc => opfc.professionalFieldID == pfc.professionalFieldID);
        if(index > -1){
          pfc.active = professionalFieldConfigList[index].active;
          pfc.required = professionalFieldConfigList[index].required;
        }
      });

      this.settingsService.updateProfessionalConfig(this.selectedProfessionalTypeConfig).subscribe( res => {
          if (res) {
            this.alertService.success('Successfully updated configuration.');
            this.existingProfRequiredEdited = false;
            this.resetAllUnpersistedValues();
            this.fetchConfig();
          } else {
            this.alertService.error('Updating configuration failed.');
          }
          this.spinner.hide();
        },
        err => {
          this.alertService.error('Updating configuration failed.');
          this.spinner.hide();
        }
      );
    } else {
      this.selectedProfessionalTypeConfig.professionalFieldConfig = professionalFieldConfigList;
      this.selectedProfessionalTypeConfig.active = this.selectedProfessionalActive;
      this.selectedProfessionalTypeConfig.required = this.selectedProfessionalRequired;
      this.settingsService.saveProfessionalConfig(this.selectedProfessionalTypeConfig).subscribe(res => {
          if (res) {
            this.alertService.success('Successfully created configuration.');
            this.fetchConfig();
          } else {
            this.alertService.error('Creating configuration failed.');
          }
        },
        err => {
          this.alertService.error('Creating configuration failed.');
        },
        () => {
          this.spinner.hide();
        }
      );
    }
  }

  filterOutRemovedQualificationsFromEduConfig() {
    this.selectedProfessionalTypeConfig.educationLevelConfig =
      this.selectedProfessionalTypeConfig.educationLevelConfig.map(
      e => ({...e, qualificationConfig: e.qualificationConfig.filter(qc => qc.isSelected)}));
  }

  removeLookupsFromProfessionalTypeConfig(professionalConfig) {
    professionalConfig.educationLevelConfig.forEach(elc => {
      elc.educationLevel = null;
      elc.qualificationConfig.forEach(qc => {
        qc.qualification = null;
        qc.specificProductItem = null;
      });
    });
    professionalConfig.professionalFieldConfig.forEach(pfc => {
      pfc.professionalField = null;
    });
    return professionalConfig;
  }
  
  activeClicked() {
    const prevActiveValue = this.professionalTypeConfigForm.controls[this.selectedProfessionalField.professionalFieldCode]
                                                                                                      .get('active').value;
    if(prevActiveValue){ // if active was true and is being set to false set required to false 
      this.professionalTypeConfigForm.controls[this.selectedProfessionalField.professionalFieldCode]
                                              .get('required').setValue(!Boolean(prevActiveValue));
    }

    this.professionalTypeConfigForm.controls[this.selectedProfessionalField.professionalFieldCode]
                                                .get('active').setValue(!Boolean(prevActiveValue));
  }

  requiredClicked() {
    const prevRequiredValue = this.professionalTypeConfigForm.controls[this.selectedProfessionalField.professionalFieldCode]
                                                                                                      .get('required').value;
    if (!prevRequiredValue) { // if req was false and is being set to true, set active to true as well
      this.professionalTypeConfigForm.controls[this.selectedProfessionalField.professionalFieldCode]
                                                  .get('active').setValue(!Boolean(prevRequiredValue));
    }
    this.professionalTypeConfigForm.controls[this.selectedProfessionalField.professionalFieldCode]
                                              .get('required').setValue(!Boolean(prevRequiredValue));
  }

  selectedProfessionalRequiredClicked(professional) {

    const professionalConfig = this.professionalConfigListForFilter.find(pc => pc.professionalTypeID === professional.id);
    if(!this.expandedProfessionalType) {
         
      if(!professionalConfig){  
        this.expandConfigView(professional, false);
        this.selectedProfessionalRequired = !this.selectedProfessionalRequired;
        if (this.selectedProfessionalRequired) {
          this.selectedProfessionalActive = true;
        } else {
          Object.keys((this.professionalTypeConfigForm as FormGroup).controls).forEach(key => {
            this.professionalTypeConfigForm.get(key).get('required').setValue(false);
          });
        }

       } else {
        professionalConfig.required = !professionalConfig.required;
        this.expandConfigView(professional, true);
        this.existingProfRequiredEdited = true;
        if(professionalConfig.required)
        {
          professionalConfig.active = true;
        } else {
          Object.keys((this.professionalTypeConfigForm as FormGroup).controls).forEach(key => {
            this.professionalTypeConfigForm.get(key).get('required').setValue(false);
          });
        }
       }
    } else if(this.expandedProfessionalType.id == professional.id){
      
      if(!professionalConfig){
        this.selectedProfessionalRequired = !this.selectedProfessionalRequired;
        if (this.selectedProfessionalRequired) {
          this.selectedProfessionalActive = true;
        } else {
          Object.keys((this.professionalTypeConfigForm as FormGroup).controls).forEach(key => {
            this.professionalTypeConfigForm.get(key).get('required').setValue(false);
          });
        }
      }else {
        professionalConfig.required = !professionalConfig.required;
        this.existingProfRequiredEdited = true;
        if(professionalConfig.required)
        {
          professionalConfig.active = true;
        } else {
          Object.keys((this.professionalTypeConfigForm as FormGroup).controls).forEach(key => {
            this.professionalTypeConfigForm.get(key).get('required').setValue(false);
          });
        }
      }
    } 
  }

  selectedProfessionalActiveClicked(professional) {
    
    // case 1: not active, no other config happening - selecting makes it active and opens config
    // case 1a: not active, another config happening - selecting warns about abandoning other config, yes? makes it active and opens config
    // case 2: active, not persisted, no other config happening - selecting makes it inactive and cancels config
    // case 3: active, persisted, no other config - selecting makes it delete the configuration after displaying a warining

    if (!this.expandedProfessionalType) { // no other config
      if (!this.professionalIsActive(professional)) { // case 1
        this.expandConfigView(professional, false);
        this.selectedProfessionalActive = true;
      } else {
        const professionalConfig = this.professionalConfigListForFilter.find(pc => pc.professionalTypeID === professional.id);
        if (!professionalConfig) { // case 2
          this.selectedProfessionalActive = false;
          this.cancelClicked(this.templateRef);
        } else { // case 3
          this.alertMessage = 'Are you sure you want to make this config inactive?';
          this.actionType = 'inactive';
          this.selectedProfessionalTypeConfig = professionalConfig;
          this.modalRef = this.modalService.show(this.templateRef);
        }
      }
    } else {
      if (!this.professionalIsActive(professional)) { // case 1a
        this.alertMessage = 'Are you sure you want to stop editing this config?';
        this.actionType = 'active';
        this.professionalToBeExpanded = professional;
        this.modalRef = this.modalService.show(this.templateRef);
      } else {
        // case 3
        const professionalConfig = this.professionalConfigListForFilter.find(pc => pc.professionalTypeID === professional.id);
        if (!professionalConfig) { // case 2
          this.selectedProfessionalActive = false;
          this.cancelClicked(this.templateRef);
        } else {
          this.alertMessage = 'Are you sure you want to make this config inactive?';
          this.actionType = 'inactive';
          this.selectedProfessionalTypeConfig = professionalConfig;
          this.modalRef = this.modalService.show(this.templateRef);
      }
      }
    }
  }

  submitButtonIsDisabled() {
    return this.professionalTypeConfigForm.invalid;
  }

  public fetchConfigIsDisabled() {
    return !this.professionalConfigFilter.applicationCategoryID ||
      !this.professionalConfigFilter.productTypeID || !this.professionalConfigFilter.facilityTypeID ||
      (this.foodManufacturerSelected && (!this.professionalConfigFilter.manufacturingRiskLevelID ||
        !this.professionalConfigFilter.manufacturingLevelID)) ||
      (this.cosmeticsManufacturerSelected && !this.professionalConfigFilter.manufacturingLevelID) ||
      (this.medicalDeviceSelected && !this.professionalConfigFilter.specificProductItemIDs);
  }

  public fetchConfig() {
    this.getProfessionalFields();
    this.getProfessionalConfigByFilter();
    this.resetAllUnpersistedValues();
    this.professionalConfigListForFilter = [];
  }

  public professionalIsActive(professional) {
    // if professional is found in the config list or is about to be configured
    const professionalTypeConfigs = this.professionalConfigListForFilter.filter(pc => pc.professionalTypeID === professional.id);
    return (professionalTypeConfigs.length > 0 && professionalTypeConfigs[0].active) ||
      (this.selectedProfessionalActive && this.expandedProfessionalType && this.expandedProfessionalType.id === professional.id);
  }

  public professionalIsRequired(professional) {
    // if professional is found in the config list and its required or is about to be configured
    const professionalTypeConfigs = this.professionalConfigListForFilter.filter(pc => pc.professionalTypeID === professional.id);
    return (professionalTypeConfigs.length > 0 && professionalTypeConfigs[0].required) ||
      (this.selectedProfessionalRequired && this.expandedProfessionalType && this.expandedProfessionalType.id === professional.id);
  }

  public professionalRowClicked(professional) {
    
    // only used to open the config if there are no ongoing configurations
    if (!this.expandedProfessionalType) { // checks that there are no ongoing configs
        const professionalConfig = this.professionalConfigListForFilter.filter(pc => pc.professionalTypeID === professional.id);
        if (professionalConfig.length > 0) { //  checks if selected row has a config already; if it already has a config, open the config
          this.expandConfigView(professional, true);
        } else { // if not mark as active and open config
          this.selectedProfessionalActiveClicked(professional);
        }
      }
  }

  public lookupBeingSelected(professionalFieldCode) {
    const prevActiveValue = this.professionalTypeConfigForm.controls[professionalFieldCode]
      .get('active').value;
    if (!prevActiveValue) {
      this.professionalTypeConfigForm.controls[professionalFieldCode]
        .get('active').setValue(!Boolean(prevActiveValue));
    }
  }

  public cancelClicked(alertModal) {
    if (this.selectedProfessionalTypeConfig.id) {
      this.alertMessage = 'Are you sure you want to cancel editing this configuration?';
    } else {
      this.alertMessage = 'Are you sure you want to cancel creating this configuration?';
    }
    this.actionType = 'cancel';
    this.modalRef = this.modalService.show(alertModal);

  }
  public resetAllUnpersistedValues() {
    this.selectedProfessionalRequired = false;
    this.selectedProfessionalActive = false;
    this.expandedProfessionalType = null;
    this.selectedProfessionalField = null;
    this.selectedProfessionalFieldIndex = 0;
    this.selectAllEduLevelLookupChecked = false;
    this.selectAllQuaificationLookupChecked = false;
    this.selectedProfessionalTypeConfig = new ProfessionalTypeConfig();
    this.selectedEducationLevelConfig = [];
  }

  public selectAllEducationLookup() {
    this.lookupBeingSelected(Constants.EDUCATION_LEVEL_CODE);
    this.selectAllEduLevelLookupChecked = !this.selectAllEduLevelLookupChecked;
    // sets all true if select all checkbox is selected, and false it is deselected
    let allEduLevelValues = this.eduLevels.map(x => this.selectAllEduLevelLookupChecked); 
    this.professionalTypeConfigForm.get(Constants.EDUCATION_LEVEL_CODE).get('selectedValues').setValue(allEduLevelValues);
    this.professionalTypeConfigForm.get(Constants.EDUCATION_LEVEL_CODE).get('selectedValues').markAsDirty();
  }

  public selectAllQualLookup() {
    this.lookupBeingSelected(Constants.QUAL_CODE);
    this.selectAllQuaificationLookupChecked = !this.selectAllQuaificationLookupChecked;
    // sets all true if select all checkbox is selected, and false it is deselected
    let allQualValues = this.qualificationTypes.map(x => this.selectAllQuaificationLookupChecked);
    this.professionalTypeConfigForm.get(Constants.QUAL_CODE).get('selectedValues').setValue(allQualValues);
    this.professionalTypeConfigForm.get(Constants.QUAL_CODE).get('selectedValues').markAsDirty();
  }

  public closeModal() {
    this.modalRef.hide();
  }

  public makeConfigInactive(professionalConfig) {
    professionalConfig.active = false;
    professionalConfig.required = false;
    professionalConfig = this.removeLookupsFromProfessionalTypeConfig(professionalConfig);
    this.spinner.show();
    this.settingsService.updateProfessionalConfig(professionalConfig).subscribe( res => {
        if (res) {
          this.alertService.success('Successfully updated configuration.');
          this.fetchConfig();
        } else {
          this.alertService.error('Updating configuration failed.');
        }
      },
      err => {
        this.alertService.error('Updating configuration failed.');
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  takeAction(actionType) {
    switch (actionType) {
      case 'cancel':
        this.cancelAction();
        this.closeModal();
        break;
      case 'inactive':
        this.makeConfigInactive(this.selectedProfessionalTypeConfig);
        this.closeModal();
        break;
      case 'active':
        this.expandConfigView(this.professionalToBeExpanded, false);
        this.selectedProfessionalActive = true;
        this.closeModal();
        break;
    }
  }

  cancelAction()
  {
    if(this.existingProfRequiredEdited){ // required was edited but not saved so let's reload
      this.fetchConfig();
    } else {
      this.resetAllUnpersistedValues();
    }
  }

  nextButtonIsDisabled()
  {
    if(this.selectedProfessionalField.name == Constants.EDUCATION_LEVEL_LABEL){
      const selectedEduArray = this.professionalTypeConfigForm.get('EDL').get('selectedValues').value;
      return selectedEduArray ? selectedEduArray.every(e => e == false) : true;
    }else if(this.selectedProfessionalField.name == Constants.QUALIFICATION_LABEL)
    {
      const selectedQualArray = this.professionalTypeConfigForm.get('QUA').get('selectedValues').value;
      return selectedQualArray ? selectedQualArray.every(q => q == false) : false;
    }
    return false;
  }

  manufacturingLevelChange(){
    const manufacturingLevel = this.manufacturingLevel.find(m => m.id === this.professionalConfigFilter.manufacturingLevelID);
    if (!manufacturingLevel) {
      return;
    }
    if (manufacturingLevel.mLevelTypeCode !== Constants.HIGHER_MANUFACTURING) {
      this.manufacturingRiskLevel = this.allManufacturingRiskLevel.filter(mrl => mrl.mrLevelTypeCode !== Constants.MANUFACTURING_RISK_LEVEL_SPECIAL);
    }else {
      this.manufacturingRiskLevel = this.allManufacturingRiskLevel;
    }
  }

}
